// Auto-generated from proto definitions. DO NOT EDIT.

export type FiscalPaymentType = 'FISCAL_PAYMENT_TYPE_UNSPECIFIED' | 'FISCAL_PAYMENT_TYPE_CASH' | 'FISCAL_PAYMENT_TYPE_ELECTRONIC' | 'FISCAL_PAYMENT_TYPE_PREPAID' | 'FISCAL_PAYMENT_TYPE_CREDIT' | 'FISCAL_PAYMENT_TYPE_OTHER';

export const FiscalPaymentTypeValues = ['FISCAL_PAYMENT_TYPE_UNSPECIFIED', 'FISCAL_PAYMENT_TYPE_CASH', 'FISCAL_PAYMENT_TYPE_ELECTRONIC', 'FISCAL_PAYMENT_TYPE_PREPAID', 'FISCAL_PAYMENT_TYPE_CREDIT', 'FISCAL_PAYMENT_TYPE_OTHER'] as const;
